import { ErrorHandler, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SeverityNumber } from '@opentelemetry/api-logs';
import { _origError, otelLogger, setFromErrorHandler } from '../../../otel.config';

@Injectable({ providedIn: 'root' })
export class OtelErrorHandlerService implements ErrorHandler {
  private readonly router = inject(Router);

  public handleError(error: unknown): void {
    const err = error instanceof Error ? error : new Error(String(error));

    // Call original console.error for DevTools visibility, suppressing bridge re-emit.
    setFromErrorHandler(true);
    _origError(err);
    setFromErrorHandler(false);

    otelLogger.emit({
      severityNumber: SeverityNumber.ERROR,
      severityText: 'ERROR',
      body: err.message,
      attributes: {
        'error.type': err.name,
        'error.stack': err.stack ?? '',
        'browser.user_agent': navigator.userAgent,
        'url': window.location.href,
        'route': this.router.url,
      },
    });
  }
}
